import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import VueTelInput from 'vue-tel-input';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VueTelInput);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
